import { useQuery } from '@tanstack/react-query';
import { listTriggerConnections } from '@/services/triggers/triggers';
import { TriggerConnection } from '@/services/triggers/types';

export const triggerConnectionsQueryKey = (orgId?: string) => [
  'trigger-connections',
  orgId,
];

export const useListTriggerConnections = (orgId?: string, enabled = true) =>
  useQuery<TriggerConnection[]>({
    queryKey: triggerConnectionsQueryKey(orgId),
    queryFn: () => listTriggerConnections(orgId!),
    enabled: !!orgId && enabled,
  });
